import { AfterViewInit, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UiHelper } from '@helpers/ui.helper';

@Component({
  selector: 'loading-dialog',
  templateUrl: '../sharedTemplates/loading.dialog.html',
})
export class LoadingDialog implements AfterViewInit {
  constructor(private _UiHelper: UiHelper, public dialogRef: MatDialogRef<LoadingDialog>) {}

  ngAfterViewInit(): void {
    return;
  }
}
